import { t } from '../../i18n/i18n';

/**
 * A labelled value inside an `InfoPanel` — Login, Server, Broker time.
 *
 * `action` is whatever sits at the end of the value: the app's `CopyButton`
 * for something readable, or the small gradient pill (`.ip-mini`) for Show /
 * Set / Open. The pill's styling lives in InfoPanel.scss so a page can render
 * whichever element the action actually needs — a button to reveal in place, an
 * anchor to leave — without each page restating how it looks.
 *
 * Laid out by `.ip-fields`, which is a five-up grid at full width.
 */
export default function InfoField({ label, value, action, wide = false }) {
  return (
    <div className={`ip-field${wide ? ' ip-field--wide' : ''}`}>
      <span className="ip-field__label">{t(label)}</span>
      <div className="ip-field__row">
        <span className="ip-field__value">{value}</span>
        {action}
      </div>
    </div>
  );
}
